import { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Clock } from "lucide-react";
import { useEmailCapture } from "../components/EmailCaptureProvider";

export const StickyBottomBar = () => {
  const { openModal } = useEmailCapture();
  const [visible, setVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ minutes: 14, seconds: 59 });

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { minutes, seconds } = prev;
        seconds--;
        if (seconds < 0) { seconds = 59; minutes--; }
        if (minutes < 0) { minutes = 14; seconds = 59; }
        return { minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  if (!visible) return null;

  return (
    <aside
      data-testid="sticky-bottom-bar"
      className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] text-white py-3 px-4 shadow-2xl"
      role="complementary"
      aria-label="Special offer banner"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
        <div className="hidden sm:flex items-center gap-3">
          <Clock size={18} className="animate-pulse" aria-hidden="true" />
          <span className="text-sm font-medium">Offer expires in:</span>
          <time className="bg-white/20 px-2 py-0.5 rounded font-mono font-bold">
            {String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
          </time>
        </div>
        <div className="flex items-center gap-2 sm:hidden">
          <span className="text-sm font-bold">🔥 80% OFF</span>
        </div>
        <Button 
          onClick={openModal}
          data-testid="sticky-cta" 
          className="bg-white text-[#FF6B00] hover:bg-gray-100 font-bold rounded-full px-6 py-2 shadow-lg text-sm flex-shrink-0"
        >
          Claim Your Discount →
        </Button>
      </div>
    </aside>
  );
};

export default StickyBottomBar;
